import axios from "axios";

import { IHistory } from "@/shared/model/history.model";

const baseApiUrl = "api/histories";

export default class HistoryService {
  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public create(entity: IHistory): Promise<IHistory> {
    return new Promise<IHistory>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public update(entity: IHistory): Promise<IHistory> {
    return new Promise<IHistory>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public findBy360(id: number): Promise<any> {
    return new Promise<Array<any>>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/find-by-360/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
